let menuStore = {};

export function set(_menu) {
    menuStore = _menu;
}

export function get() {
    return menuStore;
}
